<div class="input-wrapper-row">
    <input nbInput fullWidth fieldSize="tiny" class="cell-element-option" type="number"/>
    <nb-select size="tiny">
        <nb-option value="px">px</nb-option>
        <nb-option value="em">em</nb-option>
        <nb-option value="rem">rem</nb-option>
    </nb-select>
</div>
<!-- <kve-width-input></kve-width-input> -->
